import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import style from './style'

import ScrollArea from '../../../partials/ScrollArea'

export const CommunityTable = props => {
  return (
    <ScrollArea
      style={{
        height: `300px`
      }}
    >
      <Col>
        <Row
          className={css(
            style.list.header,
            style[props.theme.name] ? style[props.theme.name].list.header : null
          )}
        />
        {props.communities.map((community, index) => (
          <CommunityRow
            theme={props.theme}
            key={`${index}_${community.id}`}
            onClick={props.onClick}
            {...community}
          />
        ))}
      </Col>
    </ScrollArea>
  )
}

export const CommunityRow = props => {
  const userCount = props.groups
    ? props.groups.reduce(
        (arr, g) => [
          ...arr,
          ...g.users.reduce(
            (_arr, u) => [
              ..._arr,
              ...(arr.find(_u => _u.id === u.id) ? [] : [u])
            ],
            []
          )
        ],
        []
      ).length
    : props.userCount || 0

  const groupCount = props.groups ? props.groups.length : props.groupCount || 0

  return (
    <Row
      data-comid={props.id}
      onClick={props.onClick}
      className={css(
        style.list.row,
        style[props.theme.name] ? style[props.theme.name].list.row : null,
        props.isActive
          ? style[props.theme.name]
            ? (style.list.activeRow, style[props.theme.name].list.activeRow)
            : style.list.activeRow
          : null
      )}
    >
      <Col>
        <Row>
          <Col xs='auto' />
          <Col>
            <Row>
              <Col>
                <span
                  className={css(
                    style.row.span,
                    style.row.nameSpan,
                    style.row.spanCenter
                  )}
                >
                  {props.name}
                </span>
              </Col>
            </Row>
            <Row>
              <Col>
                <span className={css(style.row.span, style.row.spanCenter)}>
                  (/{props.seo})
                </span>
              </Col>
            </Row>
          </Col>
          <Col className={`d-flex align-items-center justify-content-center`}>
            <span className={css(style.row.span, style.row.spanCenter)}>
              {groupCount} groups
            </span>
          </Col>
          <Col className={`d-flex align-items-center justify-content-center`}>
            <span className={css(style.row.span, style.row.spanCenter)}>
              {userCount} users
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default CommunityTable



// WEBPACK FOOTER //
// ./src/components/Community/partials/CommunityTable/index.js